




import Vue from 'vue';

export default Vue.extend({
  methods: {
    clickHandler(event: Event) {
      this.$emit('action', event);
    },
  },
});
